import { PublicPlacesApiFactory, V1PublicPlace, V1ToiletType, V1ToiletStatus } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { PublicPlace, Toilet, ToiletType, ToiletStatus } from '@/models'
import { api, ApiResponse, ListResponse } from './base'

function convertToiletType(rawToiletType?: V1ToiletType): ToiletType {
  switch (rawToiletType) {
    case V1ToiletType.UNKNOWNTOILETTYPE:
      return ToiletType.UNKNOWN_TOILET_TYPE
    case V1ToiletType.FORMAN:
      return ToiletType.FOR_MAN
    case V1ToiletType.FORWOMAN:
      return ToiletType.FOR_WOMAN
    case V1ToiletType.UNISEX:
      return ToiletType.UNISEX
    case V1ToiletType.MULTIPURPOSE:
      return ToiletType.MULTI_PURPOSE
    default:
      return ToiletType.UNKNOWN_TOILET_TYPE
  }
}

function convertToiletStatus(rawToiletStatus?: V1ToiletStatus): ToiletStatus {
  switch (rawToiletStatus) {
    case V1ToiletStatus.UNKNOWNTOILETSTATUS:
      return ToiletStatus.UNKNOWNTOILETSTATUS
    case V1ToiletStatus.RUNNING:
      return ToiletStatus.RUNNING
    case V1ToiletStatus.INMAINTENANCE:
      return ToiletStatus.IN_MAINTENANCE
    case V1ToiletStatus.INPREPARING:
      return ToiletStatus.IN_PREPARING
    default:
      return ToiletStatus.UNKNOWNTOILETSTATUS
  }
}

function createPublicPlaces(rawPublicPlaces?: V1PublicPlace[]): PublicPlace[] {
  if (!rawPublicPlaces) return [] as PublicPlace[]

  return rawPublicPlaces.map((pp: V1PublicPlace): PublicPlace => {
    const t = pp.toilet
    return new PublicPlace({
      websiteId: pp.websiteId,
      toiletId: pp.toiletId,
      sort: pp.sort,
      toilet: new Toilet({
        id: t?.id,
        companyId: t?.companyId,
        name: t?.name,
        toiletType: convertToiletType(t?.toiletType),
        floor: t?.floor,
        gatewayMac: t?.gatewayMac,
        boxesCount: t?.boxesCount,
        status: convertToiletStatus(t?.status)
      })
    })
  })
}

export const NewPublicPlacesApiFunc = () => {
  const webAdapter = PublicPlacesApiFactory(undefined, api.defaults.baseURL, api)

  return {
    listPublicPlaces: async (companyId: string, websiteId: string, filter?: string, page?: number): Promise<ApiResponse<ListResponse<PublicPlace>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listPublicPlaces(companyId, websiteId, filter, page)
        data = createPublicPlaces(res.data.publicPlaces)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as PublicPlace[]
        err = e
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    },

    getPublicPlace: async (companyId: string, websiteId: string, toiletId: string): Promise<ApiResponse<PublicPlace | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.getPublicPlace(companyId, websiteId, toiletId)
        data = createPublicPlaces([res.data])[0]
      } catch (e) {
        err = e
      }

      return {
        data,
        err,
      }
    },

    updatePublicPlaces: async (companyId: string, websiteId: string, publicPlaces: PublicPlace[]): Promise<ApiResponse<PublicPlace | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updatePublicPlaces(companyId, websiteId, { data: publicPlaces })
        data = createPublicPlaces([res.data])[0]
      } catch (e) {
        err = e
      }

      return {
        data,
        err,
      }
    }
  }
}